import { useForm } from 'react-hook-form'
import { Alert, Box, Button, TextField, Typography } from '@mui/material'
import { useState } from 'react'

const PasswordChangeForm = (props) => {

  const { register, handleSubmit, control, reset, formState: { errors } } = useForm()
  const [confirmPasswordError, setConfirmPasswordError] = useState(null);


  const onSubmit = (row) => {
    setConfirmPasswordError(null)
    if (row.newpassword !== row.confirmpassword) {
      setConfirmPasswordError("新しいパスワードと確認用パスワードが一致していません");
    }else{
      props.process(row)
      reset();
    }

  }


  return (
    <>
      <Box sx={{ background: '#FFFFFF', mt: 2 }}>
        <Box sx={{ mt: 2 }}>
          <Typography sx={{ mt: 2 }} variant={'h6'}>パスワード設定</Typography>
        </Box>
        <form>
          { props.current &&
          <Box sx={{ ml: 1, paddingTop: 1 }}>
            <TextField
              label='現行パスワード'
              type={'password'}
              sx={{ mb: 1, ml: 1, mr: 1 }}
              {...register('currentpassword', {
                required: true,
              })}
              size='small'
            />
            {errors.currentpassword?.type === 'required' && <Alert sx={{width:'60%'}} severity="warning">
              現行パスワードは必須です！
            </Alert>}
          </Box>
          }
          <Box sx={{ ml: 1,mt:2 }}>
            <TextField
              label='新パスワード'
              type={'password'}
              sx={{ mb: 1, ml: 1, mr: 1 }}
              {...register('newpassword', {
                required: true,
              })}
              size='small'
            />
            {errors.newpassword?.type === 'required' && <Alert sx={{width:'60%'}} severity="warning">
              新パスワードは必須です！
            </Alert>}
          </Box>
          <Box sx={{ ml: 1,mt:2 }}>
            <TextField
              label='新パスワード(確認用)'
              type={'password'}
              sx={{ mb: 1, ml: 1, mr: 1 }}
              {...register('confirmpassword', {
                required: true,
              })}
              size='small'
            />
            {errors.confirmpassword?.type === 'required' && <Alert sx={{width:'60%'}} severity="warning">
              新パスワード(確認用)は必須です！
            </Alert>}
            {confirmPasswordError && <Alert sx={{width:'60%'}} severity="warning">
              {confirmPasswordError}
            </Alert>}
          </Box>
          <Box sx={{ mt: 1, ml: 2 }}>
            <Button onClick={handleSubmit(onSubmit)} variant={'contained'}>パスワード設定</Button>
          </Box>
        </form>
      </Box>
    </>
  )
}

export default PasswordChangeForm